import React from 'react';
import { SkeletonGroup, Layout, Cell, SkeletonLine } from '@wix/design-system';

export const InlineSkeletonContent = () => (
  <SkeletonGroup dataHook="widget-inline-loading">
    <Layout gap="SP2" height="48px">
      <Cell span={6}>
        <SkeletonLine />
      </Cell>
      <Cell span={8}>
        <SkeletonLine />
      </Cell>
    </Layout>
  </SkeletonGroup>
);
